import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי מרגע הפנייה?",
  answer: "אנו מתחייבים למתן מענה מהיר במיוחד. ברוב המקרים, נוכל להציב מטפל סיעודי מקצועי בבית המטופל או בבית החולים בתוך פחות מ-5 שעות מרגע אישור הבקשה."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה רפואית?",
  answer: "כל המטפלים בצוות שלנו עוברים סינון קפדני והכשרות ייעודיות לטיפול סיעודי. הם בעלי ניסיון רב בעבודה עם קשישים, חולים כרוניים ושיקום לאחר ניתוחים."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "בוודאי. המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד מסביב לשעון, כולל שבתות, חגים ולילות, כדי להבטיח שהיקרים לכם לעולם לא יישארו ללא השגחה."
}, {
  question: "איך מתבצעת ההתאמה בין המטפל למטופל?",
  answer: "אנו מבצעים אבחון טלפוני ראשוני להבנת הצרכים הרפואיים והאישיים, ומתאימים מטפל בעל ניסיון רלוונטי ושפה משותפת כדי ליצור חיבור אנושי מיטבי."
}, {
  question: "האם אתם מספקים שירות גם בבתי חולים?",
  answer: "כן, אנו מציעים שירותי 'שומר לילה' או ליווי יום מלא בבתי חולים בכל רחבי הארץ, כדי להקל על המשפחה ולהבטיח טיפול צמוד ומסור גם מחוץ לבית."
}, {
  question: "מהן אפשרויות התשלום והאם יש סבסוד?",
  answer: "אנו עובדים עם מגוון אפשרויות תשלום נוחות. במקרים רבים ניתן לקבל החזרים מחברות הביטוח הפרטיות או דרך סל שירותים של קופות החולים, בהתאם לפוליסה שברשותכם."
}, {
  question: "מה קורה אם המטפל אינו מתאים לנו?",
  answer: "הנוחות שלכם היא בראש סדר העדיפויות שלנו. במידה ואין כימיה או שביעות רצון, אנו נדאג להחלפת המטפל באופן מיידי וללא עיכובים."
}];
export default function FaqAccordionSection() {
  return <section data-section-id="260590" id="שאלות-נפוצות" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
            שאלות ותשובות על שירותי הסיעוד שלנו
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            ריכזנו עבורכם את כל המידע החשוב בנוגע להזמנת מטפל סיעודי מיידי, הכשרות הצוות ותהליך העבודה מולנו.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none bg-accent rounded-lg overflow-hidden px-2 md:px-4 shadow-sm">
              <AccordionTrigger className="hover:no-underline py-5 text-base md:text-lg font-bold font-default text-foreground hover:text-secondary transition-colors [&>svg]:bg-background [&>svg]:p-1.5 [&>svg]:rounded-md [&>svg]:size-8 [&>svg]:text-primary [&>svg]:shadow-md [&[data-state=open]>svg]:text-secondary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base pb-6 pt-2 leading-relaxed font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}